import featureNames from '~/shared/constants/featureFlags';
import getHasFeature from '~/shared/utils/getHasFeature';
import { getTldLocale } from '~/shared/utils/getTldLocale';
import { getGender } from '~/shared/utils/useGender';
import { getMembership } from '~/techstyle-shared/react-accounts';
import { loadFeatures, getFeature } from '~/techstyle-shared/react-features';

import { getBuilderCollectionContent } from './getBuilderCollectionContent';

export const getGridNodeArrayFromCollectionsPageBuilderData = async ({
  ctx,
  builderData, // builder block data
  builderPageData,
}) => {
  if (!builderData) {
    return [];
  }
  const { query } = ctx;
  const productRequestParams = [];
  const rewriteFeatureData = {};
  const membership = getMembership(ctx.store.getState());
  const customer = ctx.store.getState().customer;
  const tld = ctx.store.getState().domain.tld;
  const tldLocale = getTldLocale(ctx.store.getState());
  const genderAutoFilterEnabled = builderPageData.enableBuilderGenderAutofilter;

  const { gender: userGender = null, genderFilterString } = getGender(
    ctx.store.getState()
  );

  const displayRetailPrice = await getHasFeature(
    ctx,
    featureNames.RETAILPRICETEST
  );

  const rewriteSort = rewriteFeatureData?.sort;

  let gridSortFeatureData;
  if (builderData?.gridSortFeature?.length) {
    await ctx.store.dispatch(loadFeatures([builderData.gridSortFeature]));

    const { data } = getFeature(
      ctx.store.getState(),
      builderData.gridSortFeature
    );
    gridSortFeatureData = data;
  }

  const pathname = ctx.asPath?.split('?') ? ctx.asPath?.split('?')[0] : null;
  const routeInfo = {
    canonicalPath: pathname,
  };

  const index = productRequestParams.length;
  const { productSource } = builderData;

  const productGridItemParams = {
    query,
    membership,
    customer,
    gender: userGender,
    genderFilterString,
    tldLocale,
    tld,
    rewriteSort,
    displayRetailPrice,
    genderAutoFilterEnabled,
    gridSortFeatureData,
    productSource,
    options: builderData,
    index,
    dispatch: ctx.store.dispatch,
    routeInfo,
  };

  const collectionContent = await getBuilderCollectionContent(
    productGridItemParams
  );
  return collectionContent;
};
